import { Badge, BADGE_STATUS } from "@/ui";

type YesOrNoBadgeProps = {
  value: boolean;
  successValue?: boolean;
};

export const YesOrNoBadge = ({ successValue = false, value }: YesOrNoBadgeProps) => {
  const isPositive = value === successValue;

  return (
    <Badge status={isPositive ? BADGE_STATUS.SUCCESS : BADGE_STATUS.WARNING}>
      {value ? "Yes" : "No"}
    </Badge>
  );
};
